<template>
<div id="app" class="full-page">
<div class="div-block">
   <h1 class="head-40">הרשמה</h1>
   <p>ההרשמה לאתר זה מיועדת למורים לתנ&quot;ך בו יוכלו לקבל כלים ותכניות לימודים עבור היחידות המוגברות בתנך</p>
   <p class="signin-txt">
      כבר רשום למערכת? 
      <router-link to="/login" class="link">התחבר</router-link>
   </p>
   <div class="add-new w-button" style="position: relative; margin-bottom: 16px;">
     {{file?'':'+ הוספת תמונת פרופיל '}}
     <img style="max-height:100px;" :src="filePreview">
     <input type="file" @change="uplpoadProfile($event)" width="100%" height="100%" style="position: absolute; opacity: 0; top: 0px; right: 0px; left: 0px; bottom: 0px;">
   </div>
   <input type="text" class="text-field w-input" maxlength="256" name="name" data-name="name" v-model="form.name" placeholder="שם מלא" id="name" required="">
   <input type="text" class="text-field w-input" maxlength="256" name="school" data-name="school" v-model="form.school" placeholder="בית ספר" id="school" required="">
   <input type="email" class="text-field w-input" maxlength="256" name="email" data-name="email" v-model="form.email" placeholder="דוא״ל" id="email" required="">
   <input type="password" class="text-field w-input" maxlength="256" name="password" data-name="password" v-model="form.password" placeholder="סיסמא" id="password" required="">
   <input type="password" class="text-field w-input" maxlength="256" name="password-2" data-name="Password 2" v-model="form.password2" placeholder="סיסמא בשנית" id="password-2" required="">
   <div class="w-checkbox terms"><input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" v-model="form.tos" class="w-checkbox-input checkbox"><label for="checkbox" class="checkbox-label w-form-label">אני מסכים לתנאי השימוש באתר</label></div>
   <a v-on:click="createUser()" href="#" class="button w-button">הרשמה</a>
   <p class="error">{{selectedUI.error}}</p>
</div>
</div>
</template>

<script>
export default {
  name:'register',
  data(){
    return {
      file:'',
      filePreview:'',
      form:{
        profileImg:'',
        name:'',
        school:'',
        email:'',
        password:'',
        password2:'',
        tos:''
      },
      selectedUI:{
        error:'',
      }
    }
  },
  methods:{
        createUser(){
      if (this.form.password != this.form.password2){
        this.selectedUI.error = 'סיסמאות לא תואמות';
        return
      }
      $.each(this.form,(i,e)=>{
        if (!e){
          this.selectedUI.error ='יש למלא את כל השדות';
          return
        }
      })
      if (!this.form.email.match(/^[\w.-]+@[\w-]+(?:\.[\w-]+)+$/gi)){
        this.selectedUI.error = 'כתובת מייל אינה תקינה';
        return 
      } else {this.selectedUI.error='';}
      if (!this.form.tos){
        this.selectedUI.error = 'יש לאשר אתר תנאי השימוש';
        return 
      } else {this.selectedUI.error='';}
      firebase.auth().createUserWithEmailAndPassword(this.form.email, this.form.password).then((profile)=>{
        uid = profile.user.uid
        this.submit(uid)
    })
      .catch((error)=> {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        this.selectedUI.error = error.message;
        // ...
      });
        },
        sendInfo(){
        var details = {
          email:this.form.email,
          name:this.form.name,
          school:this.form.school,
          profileImg:this.form.profileImg,
          halufot:[]
          }
        firebase.firestore().doc("collections/nZSsggipwqsg74x8nJBu/items/"+uid).set(details)
        .then((docRef)=> {
        window.location.href = '/alternatives'
        })
        },
        submit(uid){
          if (this.file){
          var storageRef = firebase.storage().ref(`${uid}/${this.file.name}`);
          var uploader = storageRef.put(this.file);
          uploader.on('state_changed', () => {
            }, (err) => {
          this.selectedUI.error = err;
          }, () => {
          uploader.snapshot.ref.getDownloadURL().then((url) => {
            console.log(url)
            this.form.profileImg = url;
            console.log(this.form.profileImg)
            this.sendInfo(uid)
          });
      });
          } else {this.sendInfo(uid)}
    },
    uplpoadProfile(e){
      var file = e.target.files[0];
      this.file = file
      this.previewImage()
    },
    previewImage(){
      var reader = new FileReader();
       reader.onload = (e)=>{
         this.filePreview = e.target.result
         //console.log(this.preview)
      //return e.target.result
      }
      reader.readAsDataURL(this.file)
    }
  }

}
</script>

<style scoped>
.add-new{
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>
